import React, { Suspense, lazy, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Banner.css";
import parse from "html-react-parser";
import { Rates } from "rate-quotes";
import useFormModal from "../Utils/useFormModal";
import useSunWestSuccessYears from '../Utils/useSunWestSuccessYears';

export default function Banner({ data, loCommonData }) {

  const { title1, title2, text1, text4, calSavingBtn, calSavingBtnLink, applyNowBtn, applyNowBtnLink, requestCallbackBtn, requestCallbackBtnLink, text2, text3, ratesTitle, ratesText } = data?.banner
  const applyNow = loCommonData?.angelaiUrl ? loCommonData?.angelaiUrl : applyNowBtnLink
  const imgCDN = process.env.REACT_APP_CDN + "refinance/images/";
  const { handleClick, renderModal } = useFormModal();
  const successYears = useSunWestSuccessYears();
  const loId = loCommonData?.loID
  const loEmail = loCommonData?.email || "";
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 991.9);

  const imgCDNURL1 = process.env.REACT_APP_CDN_URL + "swmcrealty2025/";

  return (
    <>
      <div className="banner">
      <div className="videoBackground">
        <video autoPlay muted loop playsInline className="backgroundVideo">
          <source src={isDesktop ? `${imgCDNURL1}swmcrealty-desktop.mp4` : `${imgCDNURL1}swmcrealty-mobile.mp4`} loading="eager" type="video/mp4" />
        </video>
      </div>

        <Container className="bannercontainer">
          <Row>
            <Col sm={12} md={12} lg={12}>
              <h1 className="title"><span className="title1">{parse(title1)}</span><span className="title2"> {parse(title2)}</span></h1>
              <h3 className="text1">{parse(text4)}</h3>
              <h3 className="text1">{parse(text1)}</h3>
              <div className="rate-div-content">
                <div className="today-rate-div">
                  {/* <img src={imgCDN + "today-rate-border-left.webp"} alt="border" loading="lazy" />
                  <div className="banner-rate-div">
                    <p className="banner-rate-title">{parse(ratesTitle)}</p>
                    <p className="banner-rate-text">{parse(ratesText)}</p>
                  </div>
                  <img src={imgCDN + "today-rate-border-right.webp"} alt="border" loading="lazy" /> */}
                   <Col sm={12} md={10} lg={10} className="ratesdisplaycontainer">
                  <div className="today-rate-showingrates">
                    <Suspense fallback={<div>Loading...</div>}>
                      <Rates leadSource="NET007" />
                    </Suspense>
                  </div>
                  </Col>
                </div>

              </div>
              {/* <div className="btn-div-apply">
                <button className="apply-now-btn" >
              </div> */}
              <div className="btn-div">
                <button className="cal-sav-btn" onClick={() => handleClick(applyNow)}>{applyNowBtn}</button>
                <button className="request-callback-btn" onClick={() => handleClick(requestCallbackBtnLink)}>{requestCallbackBtn}</button>
              </div>
              <p className="text2">{parse(text2)} {successYears} {parse(text3)}</p>
              {renderModal()}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}
